// extracted by mini-css-extract-plugin
module.exports = {"header":"InactiveInviteView_header__2Wttn","description":"InactiveInviteView_description__2uu0h","link":"InactiveInviteView_link__waBta"};